import React, { useState } from 'react';
import { 
  ArrowPathIcon, 
  MapPinIcon, 
  CalendarIcon, 
  BuildingOfficeIcon, 
  PhoneIcon, 
  ClockIcon,
  ChevronDownIcon,
  ChevronUpIcon
} from '@heroicons/react/24/outline';

const ShopsList = ({ shops, loading, selectedService, selectedDate, onSelectTimeSlot }) => {
  const [selectedShopId, setSelectedShopId] = useState(null);

  const formatTimeSlot = (start, end) => {
    const startTime = new Date(start).toLocaleTimeString('ro-RO', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: false
    });
    
    const endTime = new Date(end).toLocaleTimeString('ro-RO', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: false
    });
    
    return `${startTime} - ${endTime}`;
  };

  const getValidTimeSlots = (slots) => {
    const now = new Date();
    return slots.filter(slot => new Date(slot.slotStart) > now);
  };

  const handleShopClick = (shopId) => {
    setSelectedShopId(selectedShopId === shopId ? null : shopId);
  };

  if (loading) {
    return (
      <div className="bg-white dark:bg-slate-800 shadow-sm border border-slate-200 dark:border-slate-700 overflow-hidden">
        <div className="bg-gradient-to-r from-purple-600 to-purple-700 px-4 py-3">
          <div className="flex items-center gap-3">
            <div className="p-1.5 bg-white/20 rounded-lg">
              <ArrowPathIcon className="h-5 w-5 text-white animate-spin" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-white">Se încarcă...</h3>
              <p className="text-purple-100 text-sm">Căutăm service-urile disponibile</p>
            </div>
          </div>
        </div>
        <div className="p-8 flex items-center justify-center">
          <div className="text-center">
            <ArrowPathIcon className="h-8 w-8 text-purple-600 animate-spin mx-auto mb-3" />
            <span className="text-slate-700 dark:text-slate-300 font-medium">Se încarcă service-urile...</span>
          </div>
        </div>
      </div>
    );
  }

  if (!shops.length) {
    return (
      <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 overflow-hidden">
        <div className="bg-gradient-to-r from-gray-600 to-gray-700 px-4 py-3">
          <div className="flex items-center gap-3">
            <div className="p-1.5 bg-white/20 rounded-lg">
              <BuildingOfficeIcon className="h-5 w-5 text-white" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-white">Service-uri</h3>
              <p className="text-gray-100 text-sm">Nu s-au găsit rezultate</p>
            </div>
          </div>
        </div>
        <div className="p-8 text-center">
          <div className="p-4 bg-slate-100 dark:bg-slate-700 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
            <BuildingOfficeIcon className="h-8 w-8 text-slate-400 dark:text-slate-500" />
          </div>
          <h4 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">
            Nu au fost găsite service-uri
          </h4>
          <p className="text-slate-600 dark:text-slate-400 mb-1">
            Nu am putut găsi service-uri disponibile pentru criteriile selectate.
          </p>
          <p className="text-sm text-slate-500 dark:text-slate-500">
            Încercați să selectați alt oraș sau altă dată.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 overflow-hidden">
      {/* Header */}
  
      
      {/* Shops List */}
      <div className="divide-y divide-gray-200 dark:divide-gray-700 max-h-[600px] overflow-y-auto">
        {shops.map((shop) => {
          const availableSlots = getValidTimeSlots(shop.availableSlots);
          const isExpanded = selectedShopId === shop.shopId;
          
          return (
            <div 
              key={shop.shopId} 
              className=" "
            >
              <div 
                onClick={() => handleShopClick(shop.shopId)}
                className={`p-4 cursor-pointer hover:bg-slate-50 dark:hover:bg-purple-900/20  ${
                  isExpanded ? 'bg-slate-50 dark:bg-slate-800' : ''
                }`}
              >
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2">
                      <h4 className="font-semibold text-slate-900 dark:text-white text-lg">
                        {shop.brandName}
                      </h4>
                      <div className="flex items-center gap-2">
                        {/* <span className="bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 text-xs font-medium py-1 px-2 rounded-full flex items-center gap-1">
                          <CheckCircleIcon className="h-3 w-3" />
                          Disponibil
                        </span> */}
                        <span className="bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300 text-xs font-medium py-1 px-2 rounded-full">
                          {availableSlots.length} {availableSlots.length === 1 ? 'slot' : 'sloturi'}
                        </span>
                      </div>
                    </div>
                    
                    <div className="space-y-2">
                      <div className="flex items-start gap-2 text-sm text-slate-600 dark:text-slate-400">
                        <MapPinIcon className="h-4 w-4 mt-0.5 flex-shrink-0" />
                        <span>{shop.address}</span>
                      </div>
                      
                      {shop.phone && (
                        <div className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
                          <PhoneIcon className="h-4 w-4 flex-shrink-0" />
                          <span>{shop.phone}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  
                  <button className={`p-2 rounded-lg   ${
                    isExpanded 
                      ? 'bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-300 shadow-sm' 
                      : 'text-slate-400 hover:text-slate-600 dark:text-slate-500 dark:hover:text-gray-300 hover:bg-slate-100 dark:hover:bg-gray-200'
                  }`}>
                    {isExpanded 
                      ? <ChevronUpIcon className="h-5 w-5" /> 
                      : <ChevronDownIcon className="h-5 w-5" />}
                  </button>
                </div>
              </div>
              
              {isExpanded && (
                <div className="px-4 pb-4 bg-slate-50 dark:bg-slate-800 border-t border-slate-200 dark:border-slate-700">
                  <div className="pt-4">
                    <div className="flex items-center gap-2 mb-4">
                      <ClockIcon className="h-5 w-5 text-purple-600 dark:text-purple-400" />
                      <h5 className="text-sm font-semibold text-slate-700 dark:text-slate-300">
                        Intervale orare disponibile
                      </h5>
                    </div>
                    
                    {availableSlots.length > 0 ? (
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {availableSlots.map((slot, index) => (
                          <button
                            key={index}
                            onClick={() => onSelectTimeSlot && onSelectTimeSlot(shop, slot)}
                            className="flex items-center gap-3 p-3 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-purple-50 dark:hover:bg-purple-900/20 hover:border-purple-300 dark:hover:border-purple-500 hover:shadow-sm transition-all group"
                          >
                            <CalendarIcon className="h-5 w-5 text-purple-600 dark:text-purple-400" />
                            <span className="text-sm font-medium text-slate-700 dark:text-slate-300 group-hover:text-slate-900 dark:group-hover:text-white">
                              {formatTimeSlot(slot.slotStart, slot.slotEnd)}
                            </span>
                          </button>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-6 bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700">
                        <ClockIcon className="h-8 w-8 text-slate-400 dark:text-slate-500 mx-auto mb-2" />
                        <p className="text-slate-500 dark:text-slate-400 font-medium">
                          Nu există intervale orare disponibile
                        </p>
                        <p className="text-sm text-slate-400 dark:text-slate-500 mt-1">
                          pentru data selectată
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ShopsList;
